(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__pepasAccordionSwiperInit) return;
    window.__pepasAccordionSwiperInit = true;

    function parseGapPx(el) {
      const raw = getComputedStyle(el).getPropertyValue('--accordion-image-gap');
      const n = parseFloat(raw);
      return Number.isFinite(n) ? n : 0;
    }

    function initWithSwiper(el) {
      if (!window.Swiper) return false;
      try {
        // eslint-disable-next-line no-new
        new window.Swiper(el, {
          loop: true,
          slidesPerView: 'auto',
          spaceBetween: parseGapPx(el),
          allowTouchMove: true,
          watchOverflow: true,
          navigation: false,
          pagination: false,
        });
        return true;
      } catch (e) {
        return false;
      }
    }

    function initInfiniteScrollFallback(el) {
      const wrapper = el.querySelector('.swiper-wrapper');
      if (!wrapper) return;
      const originalSlides = Array.from(wrapper.children);
      if (originalSlides.length < 2) return;

      const originalHTML = wrapper.innerHTML;
      const COPIES = 5;
      wrapper.innerHTML = originalHTML.repeat(COPIES);

      let setWidth = 0;
      let middleStart = 0;
      let raf = 0;

      function measure() {
        setWidth = wrapper.scrollWidth / COPIES;
        middleStart = setWidth * Math.floor(COPIES / 2);
        if (Number.isFinite(setWidth) && setWidth > 0) el.scrollLeft = middleStart;
      }

      function scheduleMeasure() {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(measure);
      }

      const ro = new ResizeObserver(scheduleMeasure);
      ro.observe(wrapper);
      scheduleMeasure();

      let ticking = false;
      el.addEventListener(
        'scroll',
        function () {
          if (!setWidth || ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            const offset = el.scrollLeft - middleStart;
            if (offset < -setWidth / 2) el.scrollLeft += setWidth;
            if (offset > setWidth / 2) el.scrollLeft -= setWidth;
          });
        },
        { passive: true }
      );

      let dragging = false;
      let dragStartX = 0;
      let dragStartScroll = 0;
      let moved = false;

      el.addEventListener('pointerdown', function (e) {
        const t = e.target;
        if (t && t.closest && t.closest('button, input, textarea, select, video, iframe, deferred-media')) return;
        dragging = true;
        moved = false;
        dragStartX = e.clientX;
        dragStartScroll = el.scrollLeft;
        el.classList.add('is-dragging');
        if (e.pointerType === 'mouse') e.preventDefault();
        try {
          el.setPointerCapture(e.pointerId);
        } catch (err) {}
      });

      el.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        const dx = e.clientX - dragStartX;
        if (Math.abs(dx) > 6) moved = true;
        el.scrollLeft = dragStartScroll - dx;
      });

      function endDrag() {
        dragging = false;
        el.classList.remove('is-dragging');
      }

      el.addEventListener('pointerup', endDrag);
      el.addEventListener('pointercancel', endDrag);

      el.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });

      el.addEventListener(
        'click',
        function (e) {
          if (!moved) return;
          const a = e.target && e.target.closest ? e.target.closest('a') : null;
          if (a) e.preventDefault();
        },
        true
      );
    }

    function initOne(el) {
      if (!(el instanceof HTMLElement)) return;
      if (el.dataset.swiperInitialized === 'true') return;
      el.dataset.swiperInitialized = 'true';

      const usedSwiper = initWithSwiper(el);
      if (!usedSwiper) initInfiniteScrollFallback(el);
    }

    function initAll(root) {
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-accordion-swiper]').forEach(initOne);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target) initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
